export default "__VITE_ASSET__CwLYGyPH__"